<template>
  <!-- Sign Up Layout -->
  <div class="session-wrapper fade-in-up sign-up-page">
    <div class="container container-full-width">
      <div class="row">
        <div v-show="done == false" class="mx-auto">
          <div class="row no-gutters align-items-center">
            <div class="">
              <!-- <div class="card border-0 p-5 card-shadow"> -->
              <form
                class="session-form mb-4"
                action="javascript:void(0)"
                method="post"
              >
                <div class="social-widget mb-4">
                  <h2 class="text-capitalize font-2x mb-4">
                    {{ $t("ChangePassword") }}
                  </h2>
                </div>
                <!-- Social widget closed -->
                <div class="form-group">
                  <label for="InputEmail1">{{ $t("CurrentPassword") }}</label>
                  <input
                    v-model="Model.old_password"
                    type="password"
                    class="form-control form-control-lg"
                    id="password"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="password">{{ $t("NewPassword") }}</label>
                  <input
                    v-model="Model.new_password"
                    type="password"
                    class="form-control form-control-lg"
                    id="password"
                    required
                  />
                </div>
                <div class="form-group mb-4">
                  <label for="c-password">{{ $t("ConfirmPassword") }}</label>
                  <input
                    v-model="ConfirmPassword"
                    type="password"
                    class="form-control form-control-lg"
                    id="c-password"
                    required
                  />
                </div>
                <div class="form-group">
                  <button
                    :disabled="!validateForm"
                    type="submit"
                    class=" rounded-pill btn btn-primary btn-block btn-lg submit-btn"
                    @click="ChangePassword"
                  >
                    {{ $t("Change") }}
                  </button>
                </div>
              </form>
              <!-- session form closed -->
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- when change password done -->
      <div v-show="done == true" class="row">
        <div class="col-sm-12 col-md-10 col-lg-8 mx-auto">
          <div class="thankyou-wrap text-center">
            >
            <img src="/static/img/changePassword.png" alt="Card image" />

            <h3 class="text-center p-3 mb-4">{{ $t("PasswordUpdated") }}</h3>
            <p class="text-muted text-center font-sm border-style">
              {{ $t("YourPasswordHasBeenUpdatedSuccessfully") }}
            </p>

            <div class="col-md-9 text-center mt-4">
              <router-link class="navbar-brand" to="/home">
                <button
                  type="submit"
                  class="rounded-pill btn btn-primary btn-block btn-lg submit-btn"
                  icon="fa fa-arrow-Left"
                >
                  {{ $t("BackToHome") }}
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- container closed -->
  </div>
  <!-- session Wrapper closed -->
</template>
<script>
export default {
  data() {
    return {
      done: false,
      Model: {
        old_password: "",
        new_password: "",
      },
      ConfirmPassword: "",
    };
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.Model.old_password !== "" &&
        this.Model.new_password !== "" &&
        this.Model.new_password == this.ConfirmPassword
      );
    },
  },

  methods: {
    ChangePassword() {
      debugger;
      this.$store
        .dispatch("auth/ChangePassword", this.Model)
        .then(() => {
          this.done = true;
        })
        .catch(() => {});
    },
  },
  created() {
    this.done = false;
  },
};
</script>
